export function Metric({ label, value, note }: { label: string; value: string | number; note?: string }) {
  return (
    <div className="stat-card">
      <div className="stat-value text-accent">{value}</div>
      <div className="stat-label">{label}</div>
      {note && <div className="text-muted text-sm mt-2">{note}</div>}
    </div>
  )
}
